import React from 'react';
import { Authenticator as AmplifyAuthenticator, Heading } from '@aws-amplify/ui-react';

export const signUpComponents = {
  SignIn: {
    Header() {
      return (
        <Heading
          placeholder="Confirm Sign Up"
          padding={`32px 0 0 32px`}
          level={5}
          onPointerEnterCapture={null}
          onPointerLeaveCapture={null}
        >
          Confirm Sign Up Email
        </Heading>
      );
    },
    Footer() {
      return <div />;
    },
  },
  ForceNewPassword: {
    Header() {
      return (
        <Heading
          placeholder="Create password"
          padding={`0 0 12px 0`}
          level={5}
          onPointerEnterCapture={null}
          onPointerLeaveCapture={null}
        >
          Create Password 1
        </Heading>
      );
    },
    FormFields() {
      return (
        <>
          <AmplifyAuthenticator.ForceNewPassword.FormFields />
        </>
      );
    },
    FormFooter() {
      return <div />;
    },
  },
  ResetPassword: {
    Header() {
      return (
        <Heading
          placeholder="Reset your password"
          padding={`0 0 12px 0`}
          level={5}
          onPointerEnterCapture={null}
          onPointerLeaveCapture={null}
        >
          Create Password 1
        </Heading>
      );
    },
  },
  ConfirmResetPassword: {
    Header() {
      return (
        <Heading
          placeholder="Reset your password"
          padding={`0 0 12px 0`}
          level={5}
          onPointerEnterCapture={null}
          onPointerLeaveCapture={null}
        >
          Create password
        </Heading>
      );
    },
  },
};

export const components = {
  SignIn: {
    Header() {
      return (
        <Heading
          placeholder="Login"
          padding={`32px 0 0 32px`}
          level={5}
          onPointerEnterCapture={null}
          onPointerLeaveCapture={null}
        >
          Login
        </Heading>
      );
    },
  },
  ResetPassword: {
    Header() {
      return (
        <Heading
          placeholder="Reset your password"
          padding={`0 0 12px 0`}
          level={5}
          onPointerEnterCapture={null}
          onPointerLeaveCapture={null}
        >
          Reset your password
        </Heading>
      );
    },
  },
  ConfirmResetPassword: {
    Header() {
      return (
        <Heading
          placeholder="Reset your password"
          padding={`0 0 12px 0`}
          level={5}
          onPointerEnterCapture={null}
          onPointerLeaveCapture={null}
        >
          Reset your password
        </Heading>
      );
    },
  },
};

export const formFields = {
  signIn: {
    username: {
      placeholder: 'Enter Your Email Here',
      isRequired: true,
      label: 'Email Address',
    },
  },
  resetPassword: {
    username: {
      placeholder: 'Enter Your Email Here',
      isRequired: true,
      label: 'Email Address',
    },
  },
};

export const getSignUpFormFields = (searchParams: any) => ({
  signIn: {
    username: {
      placeholder: 'Enter Your Email Here',
      defaultValue: searchParams.email,
      isRequired: true,
      label: 'Email Address',
    },
    password: {
      placeholder: 'Enter Your Verification Code Here',
      defaultValue: searchParams.verification_code,
      isRequired: true,
      label: 'Verification Code',
    },
  },
  ForceNewPassword: {
    name: {
      placeholder: 'Enter Your Email Here',
      defaultValue: searchParams.email,
      isRequired: true,
      label: 'Email Address',
    },
  },
});
